<template>
  <div class="body">
      <Headtow></Headtow>
      <div  id="bj">
        <div id="w-center">
          <div id="Breadcrumb">
            <i class="el-icon-house Breadcrumb-i" ></i>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>会员中心</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- 左侧 -->
          <Memberleft></Memberleft>

          <!-- 左侧结束 -->
          <div class="w-products rihgt">
            <div class="Member-right">
                <p class="content-jj">会员中心</p>
            </div>
            <div class="h-20"></div>
            <div class="w-products rihgt Member-right">
              <div class="member-label">
                <el-tabs>
                  <el-tab-pane label="我的评价" v-loading="loading">
                    <div v-for="(item, index) in list" :key="item.id" >
                      <img :src="item.headimgurl" alt="" v-if="item.headimgurl" class="member-tx">
                      <img src="../../static/img/indextj3.jpg" alt=""  v-else  class="member-tx"/>
                      
                      <p class="memberappraise-tel">{{item.tel}}</p>
                      <div class="clear"></div>
                      <p class="memberappraise-time">{{item.create_time}}</p>
                      <div class="forum-li">
                         <router-link :to="{path:'/ProductsCont',query: {id: item.productid}}">
                          <div class="Forum-wen sc">{{item.content}}</div>
                         </router-link>
                        <div class="h-20"></div>
                         <ul id="products-content" class="memberappraise-list">
                             <li>
                               <router-link :to="{path:'/ProductsCont',query: {id: item.productid}}">
                                 <div class="products-content-left">
                                     <img :src="item.picurl" alt="">
                                 </div>
                                 <div class="products-content-center">
                                     <div class="h-10"></div>
                                     <p class="products-content-center-title">{{item.title}}</p>
                                     <div class="h-30"></div>
                                     <p class="products-content-center-bq">{{item.money}}</p>
                                 </div>
                                 <div class="clear"></div>
                               </router-link>
                              </li>
                         </ul>
                      </div>
                  </div>
                  <div class="page">
                    <el-pagination
                      background
                      layout="prev, pager, next"
                      :page-size="6"
                      @current-change="handleCurrentChange"
                      :total="total">
                    </el-pagination>
                  </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div class="h-30"></div>
              <div class="h-30 clear"></div>
              <div class="h-30"></div>
            </div>

          </div>

          <div class="clear"></div>


        </div>
      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import memberleft from '@/components/public/memberleft.vue'
export default{
  data(){
    return {
      list:{},
      page:1,
      total:0,
      loading:true,
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Memberleft': memberleft,

  },
  mounted () {
    this.recordapi();
  },
  methods:{
    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Member/MemberAppraise",{'userid':userid,'page':this.page}).then(res => {
          console.log(res);
          that.list= res.list.data;
          that.loading = false
          this.total = res.list.total
        });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/MemberAppraise.vue